import * as yup from 'yup';

import { strings } from '../strings';

import { artistDisplayNameValidator, MAX_CHARACTERS_LENGTH, spacesValidator } from './string';

export enum RegistrationField {
  Name = 'name',
  City = 'city',
  Email = 'EmailField',
  Password = 'PasswordField',
  ConfirmPassword = 'confirmPassword',
  RevenueShare = 'revenueShare',
  Country = 'country',
  Description = 'description',
  DisplayName = 'DisplayName',
  ProfileLink = 'profileLink',
}

export const registrationShema = yup.object().shape({
  [RegistrationField.Name]: yup
    .string()
    .trim()
    .test(
      'duplicate-specials',
      'Please avoid using multiple spaces, dashes and apostrophes',
      (value) => spacesValidator(value ?? ''),
    )
    .max(
      MAX_CHARACTERS_LENGTH.FIRST_NAME_LAST_NAME_MAX_LENGTH,
      `Name can't be longer than ${MAX_CHARACTERS_LENGTH.FIRST_NAME_LAST_NAME_MAX_LENGTH} characters`,
    )
    .required(strings.createAccNameRequired),
  [RegistrationField.Email]: yup.string().trim().required(strings.createAccEmailRequired),
  [RegistrationField.DisplayName]: artistDisplayNameValidator(),
  [RegistrationField.Password]: yup
    .string()
    .trim()
    .matches(/^(?=.*[A-Z])/, '*Must contain at least one uppercase letter')
    .matches(/^(?=.*[a-z])/, '*Must contain at least one lowercase letter')
    .matches(/^(?=.*[0-9])/, '*Must contain at least one number')
    .matches(/^(?=.*[,.!@#%&])/, '*Must contain at least one special character')
    .required('Password must contain at least 8 characters.')
    .min(8, 'Password must contain at least 8 characters.'),
  /*  .oneOf([yup.ref('confirmPassword')], strings.createAccPasswordMatch), */
  [RegistrationField.ConfirmPassword]: yup
    .string()
    .trim()
    .required(strings.createAccConfirmPassword)
    .min(6, strings.createAccPasswordCharacters),
  [RegistrationField.RevenueShare]: yup
    .number()
    .positive()
    .transform((v) => (isNaN(v) ? undefined : v))
    .required(strings.revenueRequired)
    .max(100, 'Revenue can not be bigger than 100')
    .min(0, 'Revenue share can not be smaller than 0'),
  [RegistrationField.ProfileLink]: yup
    .string()
    .required('Profile Link is missing')
    .matches(/^[a-zA-Z0-9]+$/, 'Profile Link must contain only letters and numbers!')
    .min(5, 'Profile Link must contain at least 5 characters.')
    .max(30, 'Profile Link can not be longer thatn 30 characters.'),
  [RegistrationField.Description]: yup
    .string()
    .trim()
    .max(2000, 'Description cannot be longer than 2000 characters.'),
});
